<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/EzpWEq/tc-custom/9781401691424.jpg?1725275627055" alt="This image is the cover for the book Shelved Under Romance, Smitten Book Club"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Shelved Under Romance, Smitten Book Club
      </h1>
      <p class="bookDescription body article font2">
        <p><b>The century-old<i> Gentlewoman’s Guide to Love and Courtship</i> is no ordinary book club choice. But for the little book club in Smitten, Vermont, it might be their best pick yet!</b></p><p>The thick, leathery tome Heather pulled out of the dusty cardboard box was definitely coming home with her. Not only was <i>The Gentlewoman’s Guide to Love and Courtship</i> an appealing curiosity by virtue of its title; it was also written by Smitten, Vermont native Pearl Chambers, a local gentlewoman from three generations back.</p><p>Little did Heather know the repercussions this little curiosity would have on her and her friends’ romantic exploits.</p><p>When Heather and her fellow book club members begin passing the book around, their respective interpretations are unleashed on their respective love lives . . . for better or for worse. Is it a mystery? An idealist fantasy? An intimation of Jane Austen? As romantic love finds its way to each woman, the <i>Guide</i> proves itself both surprisingly prescient and hilariously irrelevant.</p><p>What’s more, a handwritten inscription indicates that the arcane book might hold the only extant clues leading to buried gold—exactly what one of the members needs to keep her house. How could they not go treasure hunting?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kristin Billerbeck
      </h2>
      
      <p class="authorDescription body article"><P>Colleen Coble is the <I>USA TODAY</I> bestselling author of more than seventy-five books and is best known for her coastal romantic suspense novels. Connect with her online at colleencoble.com; Instagram: @colleencoble; Facebook: colleencoblebooks; Twitter: @colleencoble.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Thomas Nelson
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?94eb283c